"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = polyfillCheck;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _enviro = _interopRequireDefault(require("enviro"));

// check for some polyfills and throw a console.error if they don't exist
function polyfillCheck() {
  var root = window || global;
  var canCheck = (typeof IS_STANDALONE === 'undefined' || typeof IS_STANDALONE === 'boolean' && IS_STANDALONE !== true) && root && root.hubspot;

  if (!canCheck) {
    return;
  } // checks for the symbol polyfill added by HeadJS
  // the structure was inspired by CoreJS window.core object


  var hasPolyfills = root.hubspot.polyfills !== null && (0, _typeof2.default)(root.hubspot.polyfills) === 'object' && root.hubspot.polyfills.Symbol === true;

  var isDeployed = _enviro.default.deployed('hub-http');

  if (!isDeployed && !hasPolyfills) {
    var message = "Couldn't find HeadJS polyfills.\n\nMore information: https://product.hubteam.com/docs/frontend/docs/polyfills.html"; // eslint-disable-next-line no-console

    console.error(message);
  }
}

module.exports = exports.default;